let resumeData = {
    "imagebaseurl":"https://rbhatia46.github.io/",
    "name": "Nayeem Ahmed",
    "role": "Web Developer . Programmer . Dreamer",
    "linkedinId":"Your LinkedIn Id",
    "skypeid": "Your skypeid",
    "roleDescription": "",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/nayeem-ahmed-2033aa14b/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/nayeemahmed43",
          "className":"fa fa-github"
        },
        {
          "name":"twitter",
          "url":"https://twitter.com/nayeemahmed43",
          "className":"fa fa-twitter"
        },
        {
          "name":"instagram",
          "url":"https://www.instagram.com/nayeem_ahmed___/?hl=bn",
          "className":"fa fa-instagram"
        }
      ],
    "aboutme":"Highly motivated Front-End Developer and Programmer graduated from University of Rajshahi in CSE.I like to create clean,clear and effective websites that give the user the ultimate experience.I am good at MERN stack.I have special fascination in all cutting-edge technologies and try surf on those ones.I am available for any good opportunity.",
    "address":"Dhaka, Bangladesh.",
    "cell":"+8801670261934",
    "email":"nayeemahmedru@gmail.com",
    "education":[
      {
        "UniversityName":"The LNM Insitute of Information Technology",
        "specialization":"Some specialization",
        "MonthOfPassing":"Aug",
        "YearOfPassing":"2020",
        "Achievements":"Some Achievements"
      },
      {
        "UniversityName":"Some University",
        "specialization":"Some specialization",
        "MonthOfPassing":"Jan",
        "YearOfPassing":"2018",
        "Achievements":"Some Achievements"
      }
    ],
    "work":[
      {
        "CompanyName":"Some Company",
        "specialization":"Some specialization",
        "MonthOfLeaving":"Jan",
        "YearOfLeaving":"2018",
        "Achievements":"Some Achievements"
      },
      {
        "CompanyName":"Some Company",
        "specialization":"Some specialization",
        "MonthOfLeaving":"Jan",
        "YearOfLeaving":"2018",
        "Achievements":"Some Achievements"
      }
    ],
    "skillsDescription":"Your skills here",
    "skills":[
      {
        "skillname":"HTML5"
      },
      {
        "skillname":"CSS"
      },
      {
        "skillname":"Reactjs"
      },
      {
        "skillname":"Bootstrap"
      },
    ],
    "portfolio":[
      {
        "name":"Social Networking Site",
        "description":" User can post their status Including picture as well as follow other users by sign in.",
        "imgurl":"images/portfolio/sns.jpg",
        "livesite":"https://social-networking-site-sns.herokuapp.com/",
        "github":"https://github.com/nayeemahmed43/Social-Network-Site"
      },
      {
        "name":"E-commerce Site",
        "description":"Client can buy their products from this online platform by payment.",
        "imgurl":"images/portfolio/emajohn.jpg",
        "livesite":"https://ema-john-simple-bfcf0.firebaseapp.com/",
        "github":"https://github.com/nayeemahmed43/ema-john-simple"
      },
      {
        "name":"Weather App",
        "description":"User can search with particular city name for weather forecast.",  
        "imgurl":"images/portfolio/weatherapp.jpg",
        "livesite":"https://weather-app-na.herokuapp.com/",
        "github":"https://github.com/nayeemahmed43/WeatherApp"
      },
      {
        "name":"Red Onion Restaurant",
        "description":"Client can order foods from this site by online payment.",
        "imgurl":"images/portfolio/redonion.jpg",
        "livesite":"https://red-onion-f490f.web.app/",
        "github":"https://github.com/nayeemahmed43/hot-onion-restaurant"
      },
      {
        "name":"React To-Do App",
        "description":"This is a simple to-do app that helps to make to-do list.User can delete or update item from the to-do list",
        "imgurl":"images/portfolio/todo.jpg",
        "livesite":"",
        "github":"https://github.com/nayeemahmed43/react-todolist"
      },
      {
        "name":"Hot Gadgets",
        "description":"it's a online shop for mobile, laptop and other gadgets.",
        "imgurl":"images/portfolio/hotgadget.jpg",
        "livesite":"https://nayeemahmed43.github.io/Hot-Gadgets-Ecommerce/",
        "github":"https://github.com/nayeemahmed43/Hot-Gadgets-Ecommerce"
      }
    ],
    "testimonials":[
      {
        "name":"State Management In React",
        "description":"State management is an important part for the development of React Application. There are several ways to manage state in React. You can use “Redux” or you can use “React Functional Component” with “React Hook” or you can implement “React Context API” concept to manage state...",
        "bloglink":"https://medium.com/@nayeemahmed_48263/state-management-in-react-bd55b1c77378"
      },
      {
        "name":"Firebase Authentication for Web App",
        "description":"Firstly you have to go to Firebase website and create a project. Click in “Get started” button and then create your project by clicking “Add project” button.Here I have showed some screenshots...",
        "bloglink":"https://medium.com/@nayeemahmed_48263/firebase-authentication-for-web-app-6ae9b47714fb"
      },
      {
        "name":"Things you should know in JavaScript",
        "description":"let and const both are ES6 feature. They are block level declaration that means there is no access of the variable declared by let and const. There is no variable hoisting and variable can’t be redefined in the same block when let or const is used.",
        "bloglink":"https://medium.com/@nayeemahmed_48263/things-you-should-know-in-javascript-4817ac572140"
      }
    ]
  }
  
  export default resumeData